<template>
  <div class="page-container" :class="share == 1 ? 'p50' : ''">
    <sticky>
      <div class="nav">
        <div class="search-box">
          <div class="search" @click="$router.push({ path: '/search' })">
            <!-- <i class="iconfont icon-sousuo"></i> -->
            <img src="@/assets/s-1.png" class="se-icon">
            <span>搜索老师，问题</span>
          </div>
        </div>
        <dropdown-menu active-color="#4FD9D5">
          <dropdown-item title="咨询领域">
            <div class="field">
              <div
                v-for="(item, index) in option1"
                :key="index"
                :class="{ active: item.checked }"
                @click="clickfield(item)"
              >
                {{ item.title }}
              </div>
            </div>
          </dropdown-item>
          <dropdown-item title="排序方式" ref="item2">
            <div class="sorts">
              <div
                :class="{ active: item.checked }"
                v-for="(item, index) in option2"
                :key="index"
                @click="clicksorts(item)"
              >
                <span>{{ item.name }}</span>
                <i class="iconfont icon-check" v-show="item.checked"></i>
              </div>
            </div>
          </dropdown-item>

          <dropdown-item title="筛选">
            <div class="screen">
              <div
                v-for="(item, index) in option3"
                :key="index"
                style="margin-bottom: 10px"
              >
                <div class="screen-title">{{ item.name }}</div>
                <div class="screen-option">
                  <div
                    :class="{ active: lab.checked }"
                    v-for="(lab, i) in item.list"
                    :key="i"
                    @click="clickscreen(lab, index)"
                  >
                    {{ lab.title }}
                  </div>
                </div>
              </div>
            </div>
          </dropdown-item>
        </dropdown-menu>
      </div>
    </sticky>

    <list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div
        class="teacher"
        v-for="(item, index) in list"
        :key="index"
        @click="jumpPage(item)"
      >
        <div class="teacher-info">
          <div class="teacher-head">
            <!-- <img src="https://picsum.photos/id/447/300/300" alt="" /> -->
            <van-image
              fit="cover"
              width="100%"
              height="100%"
              :src="item.avatar"
              alt=""
            />
          </div>
          <div class="right-info">
            <div class="n-p">
              <div class="t-d">
                <div class="teacher-name">{{ item.username }}</div>
                <div class="star">
                  <!-- <i class="iconfont icon-xingxing" v-for="s in 5" :key="s"></i> -->
                  <stars :num="item.quality" />
                  <span>{{ item.quality }}</span>
                </div>
              </div>
              <div class="price">
                <span>￥{{ item.price }}</span
                ><small>起</small>
              </div>
            </div>
            <div class="lable">
              <div v-for="(lab, i) in item.modeArr" :key="i">{{ lab }}</div>
            </div>
          </div>
        </div>
        <div class="van-multi-ellipsis--l3 explain">
          {{ item.introduction }}
        </div>
        <div class="three">
          <div>
            <!-- <i class="iconfont icon-pinglun"></i> -->
            <img src="@/assets/pl.png" class="s-icon">
            <span>{{ item.answer }}</span>
          </div>
          <div>
            <!-- <i class="iconfont icon-hua"></i> -->
            <img src="@/assets/h.png" class="h-icon">
            <span>{{ item.evaluate }}</span>
          </div>
          <div>
            <i class="iconfont icon-guanzhu"></i>
            <span>{{ item.fansAllNum }}</span>
          </div>
        </div>
      </div>
    </list>

    <shareBottomComp v-if="share == 1"></shareBottomComp>
  </div>
</template>

<script>
/**
@description:老师列表
@createTime:2021-08-18
@create:wq
*/
import shareBottomComp from '@/components/shareBottomComp'
import { shareJsSdk,HERF, getQueryString } from "@/utils/tool";
import { DropdownMenu, DropdownItem, List, Sticky } from "vant";
import stars from "@/components/stars";
export default {
  name: "",
  props: {},
  components: { DropdownMenu, DropdownItem, List, Sticky, stars ,shareBottomComp},
  data() {
    return {
      loading: false,
      finished: true,
      option1: [],
      option2: [],
      option3: [],
      list: [],
      page: 1,
      keywords:'',
      field:'',
      share:0
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.keywords = this.$route.query.key;
    // this.field = this.$route.query.field;
    this.screen();
    
    if (getQueryString("share")) {
      this.share = 1;
    }else{
      this.share = 0
    }
    shareJsSdk('teacherList','可以测老师')
  },
  methods: {
    jumpPage(item) {
      this.$router.push({ path: "/teacherDetails", query: { id: item.id } });
    },
    screen() {
      this.api.screen().then((res) => {
        this.option1 = res.data.field;
        this.option2 = res.data.sorts;
        this.option3 = res.data.screen;
        if (this.$route.query && this.$route.query.id) {
          const queryid = this.$route.query.id;
          this.option1.find((o) => o.id == queryid).checked = true;
        }
        this.getList();
      });
    },
    getList() {
      const field = this.option1
        .filter((o) => o.checked)
        .map((o) => o.id)
        .join(",");
      const sort = this.option2.some((o) => o.checked)
        ? this.option2.find((o) => o.checked).id
        : "";

      const sex =
        this.option3.length && this.option3[0].list.some((o) => o.checked)
          ? this.option3[0].list.find((o) => o.checked).id
          : "";
      const tag =
        this.option3.length &&
        this.option3[1].list
          .filter((o) => o.checked)
          .map((o) => o.id)
          .join(",");
      this.api
        .teacherList({ field, sort, sex, tag, page: this.page ,keyword:this.keywords})
        .then((res) => {
          this.list = [...this.list, ...res.data.data];
          if (res.data.to < res.data.per_page) {
            this.loading = true;
            this.finished = true;
          } else {
            this.loading = false;
            this.finished = false;
          }
        });
    },
    onLoad() {
      this.page++;
      this.getList();
    },
    clickfield(item) {
      if (item.checked) {
        this.$set(item, "checked", false);
      } else {
        this.$set(item, "checked", true);
      }
      this.list = [];
      this.page = 1;
      this.getList();
    },
    clicksorts(item) {
      this.option2.forEach((o) => (o.checked = false));
      this.$set(item, "checked", true);
      this.$forceUpdate();
      this.list = [];
      this.page = 1;
      this.getList();
      this.$refs.item2.toggle();
    },
    clickscreen(lab, index) {
      if (index == 0) {
        this.option3[index].list.forEach((o) => (o.checked = false));
        lab.checked = true;
      } else {
        if (lab.checked) {
          lab.checked = false;
        } else {
          lab.checked = true;
        }
      }
      this.$forceUpdate();
      this.list = [];
      this.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
@dropdown-menu-box-shadow:1px 1px 1px red;
</style>
<style lang="scss" scoped>
.nav {
  background: #ffffff;
}
.search-box {
  height: 44px;
  padding: 5px 0.24rem;
  box-sizing: border-box;
  .search {
    height: 34px;
    background: #f7f7f7;
    border: 1px solid #f0f0f0;
    border-radius: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 20px;
      color: #cccccc;
      margin-right: 0.14rem;
    }
    .se-icon{
      width: 0.3rem;
      height: 0.3rem;
      margin-right: 0.14rem;
    }
    .jiant{
      width: 0.16rem;
      height: 0.1rem;
    }
    span {
      font-size: 14px;
      font-weight: 300;
      color: #cccccc;
    }
  }
}
.teacher {
  padding: 0.38rem 0.24rem 0.22rem;
  border-bottom: 0.12rem solid #f1f1f1;
  .teacher-info {
    display: flex;

    .teacher-head {
      width: 1.28rem;
      height: 1.28rem;
      border: 2px solid #ffffff;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 0.16rem;
      img {
        width: 100%;
      }
    }

    .right-info {
      flex: 1;
      .n-p {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .teacher-name {
          font-size: 0.32rem;
          font-weight: bold;
          color: #333333;
        }
        .star {
          display: flex;
          align-items: center;
          i {
            font-size: 0.3rem;
            color: #cccccc;
            margin-right: 3px;
          }
          span {
            font-size: 0.28rem;
            font-weight: 500;
            color: #f07954;
            margin-left: 3px;
          }
        }
        .price {
          font-size: 0.2rem;
          font-weight: 400;
          color: #f05468;
          span {
            font-size: 0.32rem;
          }
          small {
            display: inline-block;
            transform: scale(0.8);
          }
        }
      }
      .lable {
        display: flex;
        flex-wrap: wrap;
        margin-top: 0.14rem;

        > div {
          height: 0.36rem;
          background: #ffeedf;
          border-radius: 0.22rem;
          font-size: 0.2rem;
          font-weight: 400;
          color: #ffa380;
          padding: 0 0.2rem;
          margin-right: 5px;
          margin-bottom: 5px;
        }
      }
    }
  }
  .explain {
    font-size: 0.28rem;
    color: #666666;
    margin-top: 0.3rem;
  }
  .three {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.18rem;
    > div {
      width: 2.26rem;
      height: 0.6rem;
      background: #f7f7f7;
      border-radius: 0.14rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.26rem;
      color: #666666;
      i {
        font-size: 0.28rem;
        color: #999999;
        margin-right: 0.14rem;
      }
      .s-icon{
        width: 0.32rem;
        height: 0.26rem;
        margin-right: 0.12rem;
      }
      .h-icon{
        width: 0.24rem;
        height: 0.28rem;
        margin-right: 0.14rem;
      }
      span{
        line-height: 1;
      }
    }
  }
}
.field {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-around;
  padding: 7px;
  > div {
    width: 100px;
    height: 40px;
    border: 1px solid #e3e3e3;
    border-radius: 5px;
    margin: 7px;
    font-size: 14px;
    background: #f8f8f8;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .active {
    border: 1px solid #34c290;
    color: #34c290;
    background: rgba(52, 194, 144, 0.11);
    font-weight: bold;
  }
}
.sorts {
  > div {
    height: 50px;
    border-bottom: 1px solid #e3e3e3;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .active {
    color: #34c290;
    i {
      color: #34c290;
      font-size: 12px;
    }
  }
}
.screen {
  padding: 10px;
  .screen-title {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    margin-bottom: 15px;
  }
  .screen-option {
    display: flex;
    flex-wrap: wrap;
    > div {
      width: 80px;
      height: 30px;
      background: #f8f8f8;
      border: 1px solid #e3e3e3;
      box-sizing: border-box;
      border-radius: 5px;
      font-size: 14px;
      font-weight: 500;
      color: #666666;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .active {
      border: 1px solid #f05468;
      background: rgba(240, 84, 104, 0.11);
      color: #f05468;
    }
  }
}
</style>
